import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';

import { HomePageComponent } from './home-page.component';
import { WelcomeComponent } from './welcome/welcome.component';

/**
 * This is a placeholder for the homepage.
 */
@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
  ],
  declarations: [
    HomePageComponent,
    WelcomeComponent
  ],
  providers: []
})
export class HomePageModule {}
